import React, {Component} from 'react';
import {Tooltip} from "antd";

class ArrayGroup extends Component {

    render() {
        let {text, exp, join, style} = this.props;
        let result = [];
        if(text && exp){
            result = text.map(function (item){
                let res = null;
                return eval(`res = ${exp}`);
            })
        }
        return (
            <div style={style}>
                <div title={result.join(join)}>{result.join(join)}</div>
            </div>
        );
    }
}

export default ArrayGroup;
